import { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import { branchesAtom, selectedBranchAtom } from 'atoms/branch';
import { paymentMethodsAtom } from 'atoms/paymentMethods';
import apiService from 'api/apiService';
import { useApplyClientConfiguration } from './useUserConfig';

export function useInitializeUser(isAuthenticated: boolean) {
  const [loaded, setLoaded] = useState(false);
  const applyClientConfiguration = useApplyClientConfiguration();
  const setBranches = useSetAtom(branchesAtom);
  const setSelectedBranch = useSetAtom(selectedBranchAtom);
  const setPaymentMethods = useSetAtom(paymentMethodsAtom);

  const fetchUserConfig = async () => {
    try {
      const [userConfig, branches, paymentMethods] = await Promise.all([
        apiService.clientConfiguration.get(),
        apiService.branches.getBranches(true),
        apiService.paymentMethods.list(),
      ]);

      applyClientConfiguration(userConfig);
      setBranches(branches);
      setPaymentMethods(paymentMethods);

      if (branches.length > 0) {
        setSelectedBranch(branches[0]);
      }
    } catch (err) {
      console.error('Failed to load user config:', err);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    fetchUserConfig();
  }, [isAuthenticated, applyClientConfiguration]);

  return loaded;
}
